<template>
  <container-app>
    <header-app
      :title="$t('Receiver_Information')"
      class="header-brand"
      to="menu"
    ></header-app>
    <wrap>
      <form>
        <div class="form-group feedback-input">
          <h4>{{ $t("Please Enter Receiver Information") }}</h4>
        </div>
        <div class="form-group">
          <label> {{ $t("Name_Receiver") }}</label>
          <input type="text" class="form-control" placeholder="Enter Name" />
        </div>
        <div class="form-group">
          <label>{{ $t("Phone_Number") }}</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Phone Number"
          />
        </div>
        <button
          type="button"
          @click="openDropMap()"
          class="btn btn-brand btn-md mt-3"
        >
          <base-icon icon_name="arrow-right-circle" />
          {{ $t("Drop Location") }}
        </button>
      </form>
    </wrap>
  </container-app>
</template>

<script>
import store from "@/store";
export default {
  layout: "default",
  name: "customer",
  metaInfo: {
    title: "DiscoverLao Ordering",
  },
  methods: {
    openDropMap() {
      this.$router.push({ name: "select_map" });
    },
  },
};
</script>